// TODO: Find a way to get eslint to recognize the following importmaps
/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html, styleMap, nothing } from 'lit-all'
import * as paths from 'lib-paths'
import { addToCart, handleize, formatMoney } from 'lib-utils'
import styles from 'lib-styles'
/* eslint-disable import/no-unresolved */

class HHCompatibleProduct extends BaseElement {
  static properties = {
    ready: {
      type: Boolean,
    },
    product: {
      type: Object,
    },
    variants: {
      type: Array,
    },
    options: {
      type: Array,
    },
    allOptions: {
      type: Array,
    },
    swatches: {
      type: Array,
    },
    nonSwatches: {
      type: Array,
    },
    activeVariant: {
      type: String,
    },
    activeIndex: {
      type: Number,
    },
    swatchVariants: {
      state: true,
    },
    compareAtPrice: {
      type: String,
      attribute: 'compare-at-price',
    },
    _loadingSubmit: {
      state: true,
    },
  }

  constructor() {
    super()
    this.activeIndex = 0
    this.product = {}
    this.variants = []
    this.options = []
    this.allOptions = []
    this.swatches = []
    this.nonSwatches = []
    this.swatchVariants = []
    this.hiddenOptions = []
    this.swatchesPosition = 0
    this.quantity = 1
    this.nonColorOptions = []
    this.selectedOptions = new Array(this?.options?.length).fill('')
    this.selectedOrFirstAvailableVariant = {}
    this.pdpVariants = {}
    this.initialRender = true
  }

  connectedCallback() {
    super.connectedCallback()
  }

  updated(changedProperties) {
    if (changedProperties.has('ready')) {
      this._setSwatchVariants()
      this.attachListeners()
      this.selectedOptions = Array.from(this.variants[0].options)
      this.setActiveVariant()
      setTimeout(() => {
        const buttons = this.shadowRoot.querySelectorAll('sl-button')
        const menus = this.shadowRoot.querySelectorAll('sl-menu')
        if (buttons.length && menus.length) {
          menus.forEach((menu, index) => {
            this.setMenuWidth(buttons[index], menu)
          })
        }
        this.setHiddenOptions()
      }, 0)
    }
  }

  attachListeners() {
    const handleUrlChange = () => {
      setTimeout(() => {
        const newVariantId = window.location.href.split('?variant=')[1]
        const newVar = this.pdpVariants.filter((variant) => {
          return variant.id === Number(newVariantId)
        })
        const newColor = newVar[0]?.option1
        this.setActiveVariant(true, newColor)
      }, 0)
    }

    let previousUrl = ''
    const observer = new MutationObserver(() => {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href
        handleUrlChange()
      }
    })
    const config = { subtree: true, childList: true }

    observer.observe(document, config)
  }

  _handleDropdownChange = (event, key) => {
    this.selectedOptions[key] = event.detail.item.value
    this.setActiveVariant()
    this.setHiddenOptions(key)
  }

  setMenuWidth = (button, menu) => {
    const buttonWidth = button.clientWidth
    const menuEle = menu
    menuEle.style.width = `${buttonWidth}px`
  }

  setHiddenOptions() {
    this.hiddenOptions = []
    this.allOptions?.forEach((option, index) => {
      if (index !== 0) {
        option.values?.forEach((optionValue) => {
          const valuesToMatch = [this.selectedOptions[0], optionValue]
          const matches = this.variants.filter((variant) => {
            return valuesToMatch.every((value) =>
              variant.options.includes(value)
            )
          })
          if (matches.length < 1) {
            this.hiddenOptions.push({
              name: option.name,
              value: optionValue,
            })
          }
        })
      }
    })
  }

  setActiveVariant(topLevelChange, newColor) {
    let pdpProductColor
    if (this.initialRender) {
      if (window.location.href.includes('?variant=')) {
        pdpProductColor = newColor
      } else {
        pdpProductColor = this.selectedOrFirstAvailableVariant?.option1
      }
    } else {
      pdpProductColor = newColor
    }

    if (
      this.swatches?.includes(pdpProductColor) &&
      (this.initialRender || topLevelChange)
    ) {
      this.selectedOptions[0] = pdpProductColor
      this.initialRender = false
    }

    const check = (variant) => {
      for (let i = 0; i < this.options.length; i += 1) {
        const key = `option${i + 1}`
        if (variant[key] !== this.selectedOptions[i]) {
          return false
        }
      }

      return true
    }

    const selectedVariants = this.variants.filter((variant) => {
      if (check(variant)) {
        return variant
      }
      return null
    })

    let selectedIndex = this.variants.findIndex((variant) => {
      return variant.id === selectedVariants[0]?.id
    })

    if (selectedIndex < 0) {
      const selectedVariantByOption1 = this.variants.filter((variant) => {
        return variant.option1 === this.selectedOptions[0]
      })
      if (selectedVariantByOption1?.[0]) {
        selectedIndex = this.variants.findIndex((variant) => {
          return variant.id === selectedVariantByOption1[0]?.id
        })
      } else {
        selectedIndex = 0
      }
    }
    this.activeIndex = selectedIndex
    this.activeVariant = this.variants[this.activeIndex]
    this.selectedOptions = Array.from(this.activeVariant.options)
  }

  _handleQuantityChange = (event) => {
    this.quantity = event.detail.value
  }

  _setSwatchVariants() {
    if (!this.swatches || !this.variants.length) return []

    const matches = this.swatches.reduce((accumulator, swatch) => {
      let match
      if (this.options?.length) {
        match = this.variants?.find((variant) => {
          return variant.options.includes(swatch)
        })
      } else {
        match = this.variants?.find((variant) =>
          variant.options.includes(swatch)
        )
      }

      if (match) {
        const swatchHandle = handleize(swatch)
        const swatchColorConfig = __THEME_GLOBALS__?.swatches[swatchHandle]
        match.swatchTitle = swatch
        match.swatchHandle = swatchHandle
        match.swatchBackground1 = 'transparent'
        match.swatchBackground2 = 'transparent'
        if (swatchColorConfig) {
          if (swatchColorConfig[0]) {
            match.swatchBackground1 = swatchColorConfig[0]
          }
          if (swatchColorConfig[1]) {
            match.swatchBackground2 = swatchColorConfig[1]
          }
        }
        accumulator.push(match)
      }
      return accumulator
    }, [])

    this.swatchVariants = matches
    return matches
  }

  get activeImage() {
    let image =
      this.variants[this.activeIndex]?.featured_image?.src ||
      this.image ||
      this.product.featured_image ||
      ''

    const isSmall = image
      .split('_')
      .some(
        (fragment) => fragment.includes('x500') || fragment.includes('500x')
      )
    if (!isSmall) {
      const fragments = image.split('.')
      fragments[fragments.length - 2] = `${
        fragments[fragments.length - 2]
      }_500x`
      image = fragments.join('.')
    }
    return image
  }

  get activePrice() {
    return formatMoney(this.activeVariant?.price)
  }

  get activeCompareAtPrice() {
    if (this.variants?.length > 1) {
      const activeVariant = this.swatchVariants[this.activeIndex]
      const _activeCompareAtPrice = parseFloat(activeVariant?.compare_at_price)
      const _activePrice = parseFloat(
        this.swatchVariants[this.activeIndex]?.price
      )
      if (!_activeCompareAtPrice) return false
      if (_activeCompareAtPrice > _activePrice) {
        return formatMoney(
          this.swatchVariants[this.activeIndex]?.compare_at_price
        )
      }
    } else {
      if (!this.compareAtPrice) return false
      if (this.compareAtPrice > this.price) {
        return formatMoney(this.compareAtPrice)
      }
    }
    return false
  }

  get activeAvailable() {
    return this.activeVariant?.available
  }

  get activeMsrp() {
    return this.activeVariant?.msrp
  }

  _handleSubmit = async (event) => {
    event.preventDefault()
    this._loadingSubmit = true

    await addToCart({
      id: this.activeVariant.id,
      quantity: this.quantity,
    })

    this._loadingSubmit = false
  }

  _renderSwatch(bg1, bg2) {
    const isLink = bg1?.includes('url')
    return html`
      <div
        class="radio__title"
        style="${styleMap({
          'background-image': isLink && bg1,
          '--primary-color': !isLink && bg1,
          '--secondary-color': !isLink && bg2,
        })}"
      >
        <span class="radio-active-circle"></span>
        <span class="radio-unavailable__cross"></span>
        <span class="radio-unavailable__cross"></span>
      </div>
    `
  }

  _renderLabelInput(value, isColor, swatchBackground1, swatchBackground2) {
    return html`
      <label class="radio" for="${value}" tabindex="0">
        <input id="${value}" type="radio" name="${value}" title="${value}" />
        ${isColor
          ? this._renderSwatch(swatchBackground1, swatchBackground2)
          : null}
      </label>
      ${value}
    `
  }

  _doesOptionIncludeValue(optionName, value) {
    const currentOption = this.allOptions.find(
      (optionObj) => optionName === optionObj.name
    )
    const valueWithinCurrentOption = currentOption?.values.includes(value)

    const hiddenMatches = this.hiddenOptions.filter((hiddenOption) => {
      return hiddenOption.name === optionName && hiddenOption.value === value
    })

    return valueWithinCurrentOption && hiddenMatches.length < 1
  }

  render() {
    if (!this.ready) return nothing
    return html`
      <div class="compatible-product">
        <div class="compatible-product-header">
          ${this.activeImage &&
          html` <img
            src=${this.activeImage}
            alt=${this.product.title}
            loading="lazy"
          />`}
          <div class="flex jcc flex-col">
            <h5 class="h5">${this.product.title}</h5>
            ${this.activeMsrp
              ? html`
                  <span id="msrp" class="price line-through">
                    MSRP ${this.activeMsrp}
                  </span>
                  <span class="price price--sale"> ${this.activePrice} </span>
                `
              : html`
                  ${this.activeCompareAtPrice
                    ? html`
                        <div>
                          <span class="price price--original line-through">
                            ${this.activeCompareAtPrice}
                          </span>
                          <span class="price price--sale"
                            >${this.activePrice}</span
                          >
                        </div>
                      `
                    : html` <span class="price">${this.activePrice}</span> `}
                `}
          </div>
        </div>
        <form @submit=${this._handleSubmit}>
          <div
            class="compatible-product-options"
            style="grid-template-columns: ${this.options?.length > 1 &&
            this.nonSwatches.length > 1
              ? '1fr 1fr'
              : '1fr'};
              display: ${this.variants.length > 1 ? 'grid' : 'none'};

              "
          >
            ${this.options.map((option, key) => {
              const colorOptionPosition = this.options.indexOf('Color')
              const colorOptionKey = `option${colorOptionPosition + 1}`

              const bg = this.variants.find(
                (variant) =>
                  variant[colorOptionKey] ===
                  this.selectedOptions[colorOptionPosition]
              )?.swatchBackground1
              const activeVariant = this.variants[this.activeIndex]
              const title = activeVariant?.options[key] || ''
              const options =
                option === 'Color' ? this.swatchVariants : this.nonSwatches

              if (options.length === 1) {
                return null
              }

              return html`
                <div class="compatible-product-option" data-option="${option}">
                  <p>${option}:</p>
                  <sl-dropdown
                    data-option="${option}"
                    @sl-select="${(e) => this._handleDropdownChange(e, key)}"
                  >
                    <sl-button slot="trigger">
                      ${option === 'Color'
                        ? html`
                            <div
                              class="flex gap075 aic jcc ${!activeVariant?.available
                                ? 'button__swatch--unavailable'
                                : ''}"
                            >
                              ${this._renderSwatch(bg)}
                              <p class="p bold">${title}</p>
                            </div>
                          `
                        : html`<p class="p bold">${title}</p>`}
                      ${paths.dropdownSmall}
                    </sl-button>
                    <sl-menu
                      style="height: ${options.length >= 5
                        ? '200px !important'
                        : 'auto'}"
                    >
                      ${option === 'Color'
                        ? this.swatchVariants.map((variant) => {
                            const value = variant[colorOptionKey]

                            if (!this._doesOptionIncludeValue(option, value))
                              return null
                            return html`
                              <sl-menu-item
                                value="${value}"
                                type="radio"
                                ?disabled=${variant.available === false}
                              >
                                <span slot="prefix"></span>
                                ${this._renderLabelInput(
                                  value,
                                  true,
                                  variant.swatchBackground1,
                                  variant.swatchBackground2
                                )}
                                <span slot="suffix"></span>
                              </sl-menu-item>
                            `
                          })
                        : this.nonSwatches?.map((value) => {
                            if (!this._doesOptionIncludeValue(option, value))
                              return null
                            return html`
                              <sl-menu-item value="${value}" type="radio">
                                ${this._renderLabelInput(value, false)}
                              </sl-menu-item>
                            `
                          })}
                    </sl-menu>
                  </sl-dropdown>
                </div>
              `
            })}
          </div>
          <div class="button-container flex">
            <div class="counter-wrapper">
              <hh-quantity-input
                initial=${this.quantity}
                style="--border-width: 0"
                @changeQuantity=${this._handleQuantityChange}
              >
              </hh-quantity-input>
            </div>
            <button
              class="button"
              ?disabled=${this.activeAvailable === false}
              ?loading=${this._loadingSubmit}
            >
              ${this.activeAvailable ? 'Add to Cart' : 'Sold out'}
            </button>
          </div>
        </form>
      </div>
    `
  }

  static styles = [
    styles.reset,
    styles.a11y,
    styles.flex,
    styles.button,
    styles.dropdown,
    styles.typography,
    styles.price,
    css`
      :host .h5 {
        margin-top: 0;
        margin-bottom: 5px;
        font-family: 'PP Right Grotesk';
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 28.8px */
      }
      .price {
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
      }
      .button-container {
        gap: 5px;
      }
      .button {
        width: 100%;
        padding: 4px 20px;
        border-radius: 5px;
      }
      sl-menu-item {
        background-color: #fff;
        cursor: pointer;
        padding: 8px;
      }
      sl-menu-item:hover {
        background-color: #f5f5f5;
      }
      sl-menu-item input {
        display: none;
      }
      .radio__title {
        border: 1px solid var(--black);
        height: 33px;
        width: 33px;
        border-radius: 100%;
        position: relative;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        background-color: var(--primary-color);
      }
      .radio__title:after {
        content: '';
        background-color: var(--secondary-color);
        display: block;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 50%;
      }
      .compatible-product {
        padding: 16px;
        border-radius: 5px;
        border: 1px solid var(--Neutral, #ababab);
      }
      .compatible-product-header {
        display: flex;
        column-gap: 8px;
      }
      .compatible-product-header div {
        flex-grow: 1;
      }
      .compatible-product-header:not(:has(.compatible-product-option)) {
        margin: 0 0 22px;
      }
      .compatible-product-option button,
      .compatible-product-option p {
        word-break: break-word;
        white-space: normal;
      }
      .compatible-product-options {
        margin-bottom: 10px;
        gap: 5px;
        max-width: 100%;
      }
      .counter-wrapper {
        border-radius: 4px;
        background-color: #fff;
        height: 45px;
        --width: 103px;
        --button-width: 14px;
        --padding: 0 20px;
        border: solid 1px #ababab;
        width: fit-content;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      .icon-redesign {
        display: block;
        width: 14px;
        height: 14px;
      }
      .compatible-product-option > p {
        margin: 0 0 6px 0;
      }
      .compatible-product-options p {
        color: var(--Dark-Green, #35332b);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
      }
      img {
        width: 110px;
        height: 110px;
      }
      .radio-unavailable__cross {
        position: absolute;
        left: 0;
        height: 1.5px;
        width: calc(100% - 1.2px);
        z-index: 3;
        display: block;
        top: 50%;
        transform: rotate(-45deg) translate(0.85px, -1.25px);
        background-color: #ffffff;
        display: none;
      }
      .button__swatch--unavailable .radio-unavailable__cross,
      sl-menu-item[disabled] .radio-unavailable__cross {
        display: block;
      }
      .radio-unavailable__cross:last-child {
        transform: rotate(-45deg) translate(0.85px, -0.25px);
        width: calc(100% - 0.5px);
        background-color: var(--black);
      }
    `,
  ]
}

customElements.define('hh-compatible-product', HHCompatibleProduct)
